import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { EVENT_URL, PRODUCT_URL } from "../../../helpers/api.routes";
import { multipartFormData } from "../../../helpers/api.services";
import { ErrorToast, SuccessToast } from "../../../shared/toasters/toasters";
import { AdminEventCategoryService } from "../../eventCategory/service";
import { CreateForm } from "./CreateForm";
import { AdminProductCategoryService } from "../../productCategory/service";

export const UpdateProduct = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState();
  const { t } = useTranslation();
  const [state, setState] = useState<any>({
    website: "",
    price: null,
    title: "",
    category: { website: "", name: "", imageName: "" },
    isActive: false,
    image: undefined,
  });
  const [image, setImage] = useState<File>();
  const submitHandler = () => {
    if (state?.id) {
      multipartFormData(
        image,
        `${PRODUCT_URL}/${state?.id}`,
        JSON.stringify({
          ...state,
          category: state?.category,
        }),
        "post"
      )
        .then((response) => {
          SuccessToast(t(`event.successfully_updated`));
          navigate("/admin/product");
        })
        .catch((error) => ErrorToast(error));
    }
  };
  useEffect(() => {
    AdminProductCategoryService.getAll({
      page: 1,
      perPage: 0,
      active: "active",
    })
      .then((response) => {
        const { data } = response;
        setCategories(data?.items);
      })
      .catch((error) => ErrorToast(error));
  }, []);
  return (
    <div className="col-12">
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          submitHandler();
        }}
      >
        <CreateForm
          setImage={setImage}
          categories={categories!}
          state={state}
          setState={setState}
        />
      </Form>
    </div>
  );
};
